module.exports = __webpack_public_path__ + "img/et-or.c248f227.svg";